// extracted by mini-css-extract-plugin
export default {"container":"HeaderMenuLinks_container__Q1V6t"};